import { useCallback, useMemo } from 'react';

import { workspacesFromMemberships } from '@/core/hooks/use-memberships-query';

import { useMyMemberships } from './use-my-memberships';

/**
 * Hook to get workspaces from the user's memberships.
 * Workspaces are derived from /workspace-members/me/memberships endpoint.
 */
export function useWorkspaces() {
  const {
    memberships,
    isLoading,
    isPending,
    isFetching,
    isFetched,
    isError,
    error,
    refetch,
  } = useMyMemberships();

  const workspaces = useMemo(
    () => workspacesFromMemberships(memberships),
    [memberships],
  );

  const refetchWorkspaces = useCallback(async () => {
    const nextMemberships = await refetch();
    return workspacesFromMemberships(nextMemberships);
  }, [refetch]);

  return {
    workspaces,
    isLoading,
    isPending,
    isFetching,
    isFetched,
    isError,
    error,
    refetch: refetchWorkspaces,
  };
}
